import {
  Box,
  Heading,
  Text,
  Button,
  Stack,
  Image,
  HStack,
  Flex,
  SimpleGrid,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAdmin } from "../../context/AdminContext";
import { useTranslation } from "react-i18next";

export default function AdminNewsList() {
  const colors = {
    teal: "#1da179",
    tealLight: "#34c49b",
    grayBg: "#f9f9f9",
  };

  const [news, setNews] = useState([]);
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const toast = useToast();

  const fetchNews = async () => {
    try {
      const res = await axios.get("https://actpolymers-spring-26d90d713ec5.herokuapp.com/api/news");
      setNews(res.data);
    } catch (err) {
      console.error("Failed to fetch news", err);
      toast({
        title: isArabic ? "فشل تحميل الأخبار" : "Failed to load news",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const deleteNews = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`https://actpolymers-spring-26d90d713ec5.herokuapp.com/api/news/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast({
        title: isArabic ? "تم حذف الخبر" : "News deleted",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      fetchNews();
    } catch (err) {
      console.error("Failed to delete news", err);
      toast({
        title: isArabic ? "فشل الحذف" : "Failed to delete",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  return (
    <Box py={10} px={6} bg={colors.grayBg} minH="100vh">
      {/* HEADER */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        mb={8}
        gap={4}
      >
        <Heading size="lg" color={colors.teal}>
          {isArabic ? "إدارة الأخبار" : "News Management"}
        </Heading>

        {isAdmin && (
          <Button
            as={Link}
            to="/admin/news/create"
            bg={colors.teal}
            color="white"
            _hover={{ bg: colors.tealLight }}
          >
            {isArabic ? "إضافة خبر" : "Add News"}
          </Button>
        )}
      </Flex>

      {/* LIST */}
      {news.length === 0 ? (
        <Text textAlign="center" color="gray.500" py={20}>
          {isArabic ? "لا توجد أخبار" : "No news available"}
        </Text>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          {news.map((item) => (
            <Box
              key={item.id}
              bg="white"
              borderRadius="xl"
              boxShadow="md"
              overflow="hidden"
              transition="all 0.3s"
              _hover={{ transform: "translateY(-5px)", shadow: "xl" }}
            >
              {item.imageUrl && (
                <Image
                  src={item.imageUrl}
                  alt={item.title}
                  h="180px"
                  w="100%"
                  objectFit="cover"
                />
              )}
              <Box p={6} textAlign={isArabic ? "right" : "left"}>
                <Text fontWeight="bold" fontSize="lg" mb={2}>
                  {item.title}
                </Text>
                <Text fontSize="sm" color="gray.600" mb={4}>
                  {item.shortDescription}
                </Text>

                {isAdmin && (
                  <HStack spacing={3} justify={isArabic ? "flex-end" : "flex-start"}>
                    <Button
                      as={Link}
                      to={`/admin/news/edit/${item.id}`}
                      size="sm"
                      bg="blue.500"
                      color="white"
                      _hover={{ bg: "blue.600" }}
                    >
                      {isArabic ? "تعديل" : "Edit"}
                    </Button>
                    <Button
                      size="sm"
                      bg="red.500"
                      color="white"
                      _hover={{ bg: "red.600" }}
                      onClick={() => deleteNews(item.id)}
                    >
                      {isArabic ? "حذف" : "Delete"}
                    </Button>
                  </HStack>
                )}
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
}
